import { Box, Drawer, Typography, IconButton } from '@mui/material';
import { IoClose } from 'react-icons/io5';
import Input from 'components/Common/Input';
import { useForm } from 'react-hook-form';
import Button from 'components/Common/Button';
import { useNavigate, useParams } from 'react-router-dom';
import { useGetWorksheet, useUpdateWorksheet } from 'apis/business/agent/worksheet/hook';
import WorksheetFormSkeleton from './WorksheetFormSkeleton';

export default function WorksheetForm() {
  const navigate = useNavigate();
  const { worksheetId } = useParams();

  const { data: worksheet, isLoading } = useGetWorksheet({ include: 'columns,rows' });

  const { handleSubmit, control } = useForm({
    values: {
      worksheet: worksheet
    }
  });

  const { mutateAsync: handleWorksheet, isPending } = useUpdateWorksheet();

  const onSubmit = async (data: any) => {
    await handleWorksheet(data);
  };

  if (isLoading) {
    return <WorksheetFormSkeleton />;
  }
  return (
    <Drawer
      anchor='right'
      open={true}
      onClose={() => navigate(-1)}
      sx={{
        '& .MuiDrawer-paper': {
          width: { xs: '100%', sm: 400, md: 600 },
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          zIndex: 100001
        }
      }}
    >
      {/* Fixed Header */}
      <Box
        sx={{
          px: 3,
          py: 2,
          borderBottom: '1px solid #DEDEDE',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexShrink: 0
        }}
      >
        <Typography variant='h6'>{worksheetId ? 'Edit' : 'Add'} worksheet</Typography>
        <IconButton onClick={() => navigate(-1)} size='small'>
          <IoClose size={24} />
        </IconButton>
      </Box>

      {/* Form with Fixed Footer */}
      <Box
        component='form'
        onSubmit={handleSubmit(onSubmit)}
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        {/* Scrollable Content */}
        <Box
          sx={{
            flex: 1,
            overflow: 'auto',
            p: 3
          }}
        >
          <Input name='worksheet.name' label='Name' control={control} fullWidth required />
        </Box>

        {/* Fixed Footer */}
        <Box
          sx={{
            px: 3,
            py: 2,
            borderTop: '1px solid #DEDEDE',
            display: 'flex',
            justifyContent: 'end',
            gap: 2,
            flexShrink: 0
          }}
        >
          <Button
            onClick={() => navigate(-1)}
            color='secondary'
            variant='outlined'
            sx={{ border: '1px solid #F3F3F3' }}
          >
            Cancel
          </Button>
          <Button type='submit' variant='contained' isPending={isPending}>
            {worksheetId ? 'Update' : 'create'}
          </Button>
        </Box>
      </Box>
    </Drawer>
  );
}
